import { render } from "./BoardBackground.vue?vue&type=template&id=6f77f739&scoped=true"
import script from "./BoardBackground.vue?vue&type=script&lang=js"
export * from "./BoardBackground.vue?vue&type=script&lang=js"

import "./BoardBackground.vue?vue&type=style&index=0&id=6f77f739&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f77f739"],['__file',"src/components/h5/board/BoardBackground.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f77f739"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f77f739', __exports__)) {
    api.reload('6f77f739', __exports__)
  }
  
  module.hot.accept("./BoardBackground.vue?vue&type=template&id=6f77f739&scoped=true", () => {
    api.rerender('6f77f739', render)
  })

}


export default __exports__